// === WEBSOCKET И ОТПРАВКА ===

import { Toast } from "../ui/components/toast";
import { ERR_GENERIC, ERR_NETWORK } from "../ui/components/errors";

// WebSocket прогресса расчёта. Он же — «признак жизни» вкладки для авто-закрытия
// приложения на бэкенде (backend/services/liveness.py): пока вкладка держит это
// соединение, сервер не гасит себя. Поэтому при обрыве ОБЯЗАТЕЛЬНО
// переподключаемся — иначе и прогресс перестанет работать, и бэкенд решит, что
// вкладку закрыли, и завершится (ложное срабатывание авто-закрытия).
let socket: WebSocket;

const handleProgress = (event: MessageEvent) => {
    let data: { progress?: number; message?: string; focus?: boolean };
    try {
        data = JSON.parse(event.data);
    } catch {
        return; // не-JSON кадр — игнорируем, не роняем обработчик
    }

    // Команда от трея «Открыть»: эта вкладка уже есть — выходим на передний
    // план вместо открытия новой. window.focus() часто блокируется браузером
    // (защита от перехвата фокуса), но пробуем — хуже не будет.
    if (data.focus) {
        try { window.focus(); } catch { /* браузер запретил — ок */ }
        return;
    }

    const progress = data.progress ?? 0;
    const message = data.message ?? "Обработка...";

    Toast.update("calc", progress);

    // если сервер шлет финальное состояние — можно красиво завершать
    if (progress >= 100) {
        Toast.success("calc", message || "Расчет завершен!");
    }
};

const connectProgressSocket = () => {
    socket = new WebSocket(`${window.location.origin.replace('http', 'ws')}/progress`);
    socket.onmessage = handleProgress;
    socket.onclose = () => {
        // Переподключаемся, пока страница открыта. Задержка — чтобы не спамить,
        // если сервер действительно недоступен.
        setTimeout(connectProgressSocket, 1500);
    };
};

connectProgressSocket();

/**
 * Отправка на бэк и подсчет двух линий
 * @param {string} sectorId - ID существующего сектора"
 */
export interface IntersectionPoint {
    thickness: number;
    ray_length: number;
}

export interface CalcResult {
    intersections: IntersectionPoint[];
    thickness: number;      // первое пересечение (обратная совместимость)
    ray_length: number;     // первое пересечение (обратная совместимость)
    entry1_found: boolean;
    entry2_found: boolean;
    plot_img: string | null;
}

export const apiCalculate = (
    sectorId: string,
    first: number[],
    second: number[]
): Promise<CalcResult> => {

    Toast.show("calc", "Выполняется расчет...");
    Toast.update("calc", 0);

    return new Promise((resolve, reject) => {

        const xhr = new XMLHttpRequest();
        xhr.open("POST", `/calculate/${sectorId}`);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.responseType = "json"; // 🔥 важно

        xhr.onload = function () {
            if (xhr.status !== 200) {
                console.error(`Ошибка ${xhr.status}`);
                // responseType = "json" → тело ошибки уже распарсено.
                // Показываем причину с бэка (напр. "Недостаточно данных в файле
                // рельефа..."), а если её нет — общий понятный фолбэк.
                const detail = xhr.response && (xhr.response as { detail?: string }).detail;
                Toast.error("calc", detail || ERR_GENERIC);
                reject(null);
                return;
            }

            Toast.success("calc", "Расчет завершен!");
            resolve(xhr.response as CalcResult);
        };

        xhr.onerror = () => {
            console.error("Запрос не удался");
            Toast.error("calc", ERR_NETWORK);
            reject(0);
        };

        xhr.send(JSON.stringify({
            start_x: first[0],
            start_y: first[1],
            end_x: second[0],
            end_y: second[1]
        }));
    });
};




/**
 * Отправка на бэк и подсчет двух линий
 * @param {string} sectorId - ID существующего сектора"
 */
export const apiFlux = (sectorId: string) => {

    Toast.show("calc", "Выполняется расчет...");
    Toast.update("calc", 0);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `/flux/${sectorId}`);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.responseType = "blob";

    xhr.onload = function () {
        if (xhr.status !== 200) {
            console.error(`Ошибка ${xhr.status}`);

            const reader = new FileReader();
            reader.onload = function () {
                if (!(reader instanceof FileReader)) return;

                const result = reader.result;
                if (typeof result !== "string") return;
                try {
                    const errorData = JSON.parse(result);
                    Toast.error("calc", errorData.detail || ERR_GENERIC);
                } catch (e) {
                    Toast.error("calc", ERR_GENERIC);
                }
            }
            reader.readAsText(xhr.response);

            return;
        }

        // успех — но прогресс уже пришёл через сокет
        Toast.success("calc", "Расчет завершен!");
    };

    xhr.onerror = () => {
        console.error("Запрос не удался");
        Toast.error("calc", ERR_NETWORK);
    };

    xhr.send();
};